import { Component } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { messenger } from 'ngx-bootstrap-icons';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/loading/loading.service';
import { users } from 'src/app/models/Login';
import { QR_registro, QR_Personalizado } from 'src/app/models/QR';
import { QrService } from 'src/app/service/qr.service';
import { StorageService } from 'src/app/service/storage.service';
import { MobileMenuService } from 'src/app/service/mobile-menu.service';

@Component({
  selector: 'app-generarqr',
  templateUrl: './generarqr.component.html',
  styleUrls: ['./generarqr.component.css']
})
export class GenerarqrComponent {
  public usuario: users | undefined;
  myAngularxQrCode: string = '';
  urlPagina: string = '';
  qrCodeDownloadLink: SafeUrl = '';
  entidad: QR_registro | undefined;
  loading$ = this.loadingService.loading$;
  esAdministrado: boolean = false;

  // --- Personalización del QR (color + ícono central) ---
  qrColor: string = '#000000';
  coloresPreset: string[] = ['#000000', '#DA291C', '#1E1E1E', '#5F6368', '#0B5FA5', '#1C7C3C'];
  qrLogoSrc: string | undefined = undefined;
  qrLogoSize: number = 50; // ~22% del ancho del QR (230px), rango seguro para que siga siendo escaneable
  private readonly LOGO_MAX_BYTES = 1024 * 1024; // 1MB

  // --- QR personalizados guardados (solo en este navegador) ---
  qrGuardados: QR_Personalizado[] = [];
  private qrGuardadoPendienteEliminar: QR_Personalizado | undefined;

  // Con ícono central se necesita mayor nivel de corrección de errores
  // (H) para que el QR siga siendo legible aunque el logo tape el centro.
  get nivelCorreccion(): 'M' | 'H' {
    return this.qrLogoSrc ? 'H' : 'M';
  }


  constructor(
    private modulesService: QrService,
    private storage: StorageService,
    private toastr: ToastrService,
    private storageService: StorageService,
    private route: Router,
    private loadingService: LoadingService,
    public mobileMenu: MobileMenuService
  ) {

  }


  ngOnInit(): void {
    //    console.log('Inicio de APP: ' + this.storageService.getUsuarioStorage);
    //    console.log('Inicio de APP salida: ' + JSON.stringify(this.storageService.getUsuarioStorage));
  this.loadingService.show();
    const usuarioStorage = this.storageService.getUsuarioStorage();

    if (!usuarioStorage || Object.keys(usuarioStorage).length === 0) {
    
      this.route.navigate(['/login']);
      this.loadingService.hide();
  
    } else {
      this.loadingService.hide();
      this.esAdministrado = this.storageService.esAdministrador();
      this.qrGuardados = this.storageService.getQRsPersonalizados();
      //agregar funciones aqui
    }
  }


  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  seleccionarColor(color: string) {
    this.qrColor = color;
  }

  onLogoSeleccionado(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.toastr.error('El ícono debe ser una imagen (PNG, JPG, SVG)', 'ERROR');
      input.value = '';
      return;
    }
    if (file.size > this.LOGO_MAX_BYTES) {
      this.toastr.error('La imagen no debe superar 1MB', 'ERROR');
      input.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.qrLogoSrc = reader.result as string;
    };
    reader.onerror = () => {
      this.toastr.error('No se pudo leer la imagen seleccionada', 'ERROR');
    };
    reader.readAsDataURL(file);
  }

  quitarIcono(inputFile: HTMLInputElement) {
    this.qrLogoSrc = undefined;
    inputFile.value = '';
  }


  registrarQR() {
    this.loadingService.show();
    //console.log('VALOR :' + this.urlPagina);

    if (this.urlPagina == null || this.urlPagina.trim() == "" || this.urlPagina == undefined) {

      this.toastr.info('ALERTA', 'Debe ingresar el campo URL');
      this.loadingService.hide();
    } else {


      this.usuario = this.storage.getUsuarioStorage();
      this.entidad = new QR_registro();
      this.entidad.id_qr = 0;
      this.entidad.url_qr = this.urlPagina;
      this.entidad.id_usuario_creacion = this.usuario?.idUser;
      this.entidad.url_qr_redirec = "";
      this.entidad.estado = 0;
      if (this.urlPagina != "" || this.urlPagina != null) {
        this.modulesService.GuardarURL(1, this.entidad).subscribe(
          message => {
            if (message[0].nro_respuesta == 0) {
              this.myAngularxQrCode = message[0].url;
              this.toastr.success('EXITO!', 'Se registro correctamente');
              this.loadingService.hide();
            }else{
              this.toastr.error( message[0].mensaje,'ERROR');
              this.loadingService.hide();
            }
          },
          error => {
            this.loadingService.hide();
            this.toastr.error('No se pudo registrar la URL. Intente nuevamente.', 'ERROR');
          }
        )
      } else {
        this.toastr.error('ERROR', 'No se pudo registrar la URL');
        this.loadingService.hide();
      }

    }
  }




  /**
   * Busca el <canvas> del QR ya renderizado en pantalla. Se reutiliza tanto
   * para la descarga (PNG/JPEG/SVG) como para capturar el thumbnail al
   * guardar una personalización.
   */
  private obtenerCanvasQR(): HTMLCanvasElement | null {
    const qrElement = document.querySelector('qrcode canvas');
    if (!qrElement) {
      console.error('QR Code element not found.');
      return null;
    }
    return qrElement as HTMLCanvasElement;
  }

  downloadQRCode(format: string): void {
    try {
      const canvas = this.obtenerCanvasQR();
      if (!canvas) {
        this.toastr.error('ERROR', 'No se encontró el elemento del código QR.');
        return;
      }

      let dataURL: string;
      if (format === 'png') {
        dataURL = canvas.toDataURL('image/png');
      } else if (format === 'jpeg') {
        dataURL = canvas.toDataURL('image/jpeg');
      } else if (format === 'svg') {
        const img = new Image();
        img.src = canvas.toDataURL('image/png');
        img.onload = () => {
          const svgData = new XMLSerializer().serializeToString(img);
          dataURL = 'data:image/svg+xml;base64,' + btoa(svgData);
          this.downloadImage(dataURL, format);
        };
        img.onerror = (e) => {
          console.error('Error loading image:', e);
          this.toastr.error('ERROR', 'Error al cargar la imagen.');
        };
        return;
      } else {
        console.error('Unsupported format');
        this.toastr.error('ERROR', 'Formato no soportado.');
        return;
      }
  
      this.downloadImage(dataURL, format);
    } catch (error) {
      console.error('Error in downloadQRCode:', error);
      this.toastr.error('ERROR', 'Ocurrió un error al descargar el código QR.');
    }
  }
  
  downloadImage(dataURL: string, format: string) {
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `qrcode.${format}`;
    link.click();
  }

  /**
   * Guarda el QR personalizado actual (color + ícono + snapshot) en la
   * galería local del usuario ("Mis QR guardados"). Solo se persiste en
   * este navegador (localStorage), no en el backend.
   */
  guardarQRPersonalizado(): void {
    if (!this.myAngularxQrCode) {
      this.toastr.info('ALERTA', 'Primero genera el código QR antes de guardarlo');
      return;
    }

    const canvas = this.obtenerCanvasQR();
    if (!canvas) {
      this.toastr.error('ERROR', 'No se encontró el elemento del código QR.');
      return;
    }

    const nuevoQR: QR_Personalizado = {
      id: Date.now().toString(),
      urlPagina: this.urlPagina,
      urlGenerada: this.myAngularxQrCode,
      color: this.qrColor,
      logoSrc: this.qrLogoSrc,
      logoSize: this.qrLogoSize,
      thumbnail: canvas.toDataURL('image/png'),
      fechaGuardado: new Date().toISOString()
    };

    this.qrGuardados = this.storageService.guardarQRPersonalizado(nuevoQR);
    this.toastr.success('EXITO!', 'QR personalizado guardado');
  }

  /**
   * Vuelve a cargar un QR guardado en el editor (URL, color e ícono) para
   * reutilizarlo, ajustarlo o descargarlo de nuevo.
   */
  usarQRGuardado(qr: QR_Personalizado): void {
    this.urlPagina = qr.urlPagina ?? '';
    this.qrColor = qr.color ?? '#000000';
    this.qrLogoSrc = qr.logoSrc;
    this.qrLogoSize = qr.logoSize ?? 50;
    this.myAngularxQrCode = qr.urlGenerada ?? '';
    this.toastr.success('EXITO!', 'QR personalizado cargado en el editor');
  }

  eliminarQRGuardado(qr: QR_Personalizado): void {
    if (!qr.id) {
      return;
    }
    this.qrGuardados = this.storageService.eliminarQRPersonalizado(qr.id);
    this.toastr.success('EXITO!', 'QR eliminado de tus guardados');
  }

  /** Recuerda cuál QR guardado se quiere eliminar mientras se confirma en el modal. */
  prepararEliminarQRGuardado(qr: QR_Personalizado): void {
    this.qrGuardadoPendienteEliminar = qr;
  }

  /** Se dispara al confirmar en el modal "¿Eliminar este QR guardado?". */
  eliminarQRGuardadoConfirmado(): void {
    if (!this.qrGuardadoPendienteEliminar) {
      return;
    }
    this.eliminarQRGuardado(this.qrGuardadoPendienteEliminar);
    this.qrGuardadoPendienteEliminar = undefined;
  }

  trackByQRGuardado(_index: number, qr: QR_Personalizado): string {
    return qr.id ?? _index.toString();
  }

  /**
   * Extrae solo el dominio de la URL guardada (sin "www.") para mostrar un
   * encabezado de tarjeta corto y legible; si la URL no es válida (falta el
   * protocolo, etc.) se muestra tal cual llegó.
   */
  obtenerHost(url: string | undefined): string {
    if (!url) {
      return '';
    }
    try {
      return new URL(url).hostname.replace(/^www\./, '');
    } catch {
      return url;
    }
  }

  /**
   * El color y el ícono ya se editan en vivo (el QR se redibuja al vuelo),
   * así que "editar" solo lleva al usuario de nuevo a los controles de
   * personalización para que siga ajustándolos.
   */
  editarQR(): void {
    document.querySelector('.personalizarQR')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /** Limpia el formulario para armar un QR personalizado distinto desde cero. */
  nuevoQR(inputFile?: HTMLInputElement): void {
    this.urlPagina = '';
    this.myAngularxQrCode = '';
    this.qrCodeDownloadLink = '';
    this.qrColor = '#000000';
    this.qrLogoSrc = undefined;
    this.qrLogoSize = 50;
    if (inputFile) {
      inputFile.value = '';
    }
  }

  salir(){
    this.storageService.removeUsuarioStorage();
    this.route.navigate(['/login/ingresar']);
  }

}
